import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const PauseIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="pause" ref={ref as any} {...props}>
      <path
        clipRule="evenodd"
        d="M9 6C8.44772 6 8 6.44772 8 7V17C8 17.5523 8.44772 18 9 18C9.55228 18 10 17.5523 10 17V7C10 6.44772 9.55228 6 9 6ZM15 6C14.4477 6 14 6.44772 14 7V17C14 17.5523 14.4477 18 15 18C15.5523 18 16 17.5523 16 17V7C16 6.44772 15.5523 6 15 6Z"
        fill="currenColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
});
